<script lang="ts" setup>
import {
  useRouterStore,
  useStatsigEventsStore,
} from '@apps/main/new-desktop/core/stores';

import { AppButton, SemboGenericHotel } from '@libs/ui';

interface GenericHotelCardProps {
  ingredientIndex: number;
}

const props = defineProps<GenericHotelCardProps>();

const statsigEventsStore = useStatsigEventsStore();
const routerStore = useRouterStore();

function openHotelSelection(): void {
  statsigEventsStore.logTripOverviewAlternativeHotelsHotelSelectionCardClicked();
  statsigEventsStore.logExperimentAccommodationActionClicked('genericCard');
  routerStore.navigateToHotelSelection({
    ingredientIndex: props.ingredientIndex,
  });
}
</script>

<template>
  <div class="generic-hotel-card">
    <div class="generic-hotel-card-content">
      <SemboGenericHotel class="generic-hotel-card-image" />
      <div class="generic-hotel-card-title">
        {{ $t('planner.generic_hotel_card_title') }}
      </div>
      <div class="generic-hotel-card-description">
        {{ $t('planner.generic_hotel_card_description') }}
      </div>
    </div>
    <div class="generic-hotel-card-actions">
      <AppButton
        type="important"
        size="medium"
        state="enabled"
        @click="openHotelSelection"
      >
        {{ $t('planner.generic_hotel_card_button_text') }}
      </AppButton>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.generic-hotel-card {
  background-color: var(--color-white);
  border-radius: var(--border-radius-8);
  border: 1px solid var(--color-neutral-30);
  padding: var(--spacing-16);
  display: flex;
  flex-direction: column;
  gap: var(--spacing-24);
  align-items: center;
  justify-content: center;

  @include for-less-or-equal-than-599-px {
    justify-content: space-between;
    width: 100%;
    height: 100%;
  }

  .generic-hotel-card-content {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: var(--spacing-16);

    @include for-less-or-equal-than-599-px {
      .generic-hotel-card-image {
        margin-top: var(--spacing-24);
        margin-bottom: var(--spacing-48);
      }
    }

    .generic-hotel-card-title {
      @include font-label-xl-bold;
    }
    .generic-hotel-card-description {
      @include font-label-m-light;
    }
  }
}
</style>
